/* eslint react/no-array-index-key: 0 */
import React from "react";
import { Field, FieldArray } from "formik";

import {
  Container,
  TrashButton,
  AdicionalButton,
  StandardItem,
} from "./styles";

import { Label, Row } from "../../../ui";
import { Input } from "../input/styles";
import IField from "../../../../interfaces/field";
import Icon from "../../../icon";
import { theme } from "../../../../styles/theme";
import { If } from "../../../if/if";

const FieldArrayComponent = FieldArray as any;

type IProps = any & IField;

const InputArray: React.FC<IProps> = ({
  title,
  submitTitle,
  standardItems = [],
  name,
  ...el
}: IProps) => (
  <FieldArrayComponent name={name}>
    {({ remove, push }: any) => (
      <Container>
        <If condition={el.values[name]?.length > 0}>
          <Label style={{ marginTop: "20px" }} isRegister={false}>
            {title}
          </Label>
        </If>

        {standardItems.map((item: any, index: number) => (
          <Row
            key={`${index}-standard`}
            style={{ gap: "13px", marginBottom: "20px", marginTop: "5px" }}
          >
            <StandardItem>{item}</StandardItem>
          </Row>
        ))}
        {el.values[name]?.length > 0 &&
          el.values[name].map((item: any, index: number) => (
            <Row
              key={index}
              style={{ gap: "13px", marginBottom: "20px", marginTop: "5px" }}
            >
              <Field
                style={{ background: theme.colors.gray400 }}
                name={`${name}.${index}`}
                placeholder="Digite aqui"
                disabled={el?.disabled === true}
                as={Input}
              />
              <TrashButton type="button" onClick={() => remove(index)}>
                <Icon name="trash" />
              </TrashButton>
            </Row>
          ))}

        <AdicionalButton type="button" onClick={() => push("")}>
          <Icon name="plus" style={{ width: "14px" }} />
          {submitTitle}
        </AdicionalButton>
      </Container>
    )}
  </FieldArrayComponent>
);

export default InputArray;
